export default "__VITE_ASSET__CxrN81e___"